// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Xn-z","outfitFeedbackSection":"Yn-z"};